<template>
  <div id="header">

    <div class="left" v-show="$store.state.showHeaderLeft">
      <div class="page">
        <svgicon class="icon" :src="$store.state.headerIcon" :width="20" :height="20"></svgicon>
        <span class="title">{{$t($store.state.headerTitle)}}</span>
      </div>
    </div>

    <div class="grow"></div>

    <div class="right">
      <div class="profile">
        <router-link :to="{ name: 'profile' }" class="link" v-if="User.token">
          <svgicon class="icon" src="svg/user.svg" :width="20" :height="20"></svgicon>
          <div class="user" v-if="User.firstName && User.lastName">{{ User.firstName }} {{ User.lastName }}</div>
        </router-link >
      </div>
      <ActionMenu icon="svg/settings.svg">
        <span class="locales item">
          <span class="locale" @click="setLocale('en')" :class="{active: this.$ts.state.locale === 'en'}">EN</span>
          <span class="locale" @click="setLocale('fr')" :class="{active: this.$ts.state.locale === 'fr'}">FR</span>
        </span>
        <a href="javascript:void(0)" v-if="User.token" class="item" @click="logout">{{$t("user.logout")}}</a>
        <router-link to="/login" v-if="!User.token && !isLogin" class="item">{{ $t("menu.login") }}</router-link>
      </ActionMenu>
    </div>

  </div>
</template>

<script>
  import Configuration from "../../../core/Configuration";
  import User from "../../../core/User";
  import moment from "moment";
  import ActionMenu from "../ActionMenu.vue";

  export default {
    name: "HeaderDesktop",

    components: { ActionMenu },

    data() {
      return {
        User
      }
    },

    computed: {
      isLogin() {
        return this.$route.name === "login";
      }
    },

    methods: {
      setLocale(locale) {
        this.$ts.commit("setLocale", locale);
        Configuration.write("locale", locale);
        moment.locale(locale);
      },
      logout() {
        User.logout();
        this.$router.push("/login");
      }
    }
  }
</script>

<style lang="scss" scoped>

  #header {
    height: 80px;
    flex-shrink: 0;
    background-color: white;
    display: flex;
    align-items: center;
  }

  .left {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-left: 30px;
  }

  .logo {
    width:300px;
    height: 100%;
    background-color: #0d232d;
    margin-right: 30px;
    fill: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .page {
    display: flex;
    align-items: center;

    .icon {
      margin-right: 20px;
      fill: #bfc5c8;
    }

    .title {
      color: #001722;
      font-weight: bold;
    }
  }

  .grow {
    flex-grow: 1;
    flex-basis: 0;
  }

  .locales {
    padding: 20px 15px 0 15px;
    display: flex;
    justify-content: space-around;
  }

  .locale {
    cursor: pointer;
    padding: 0 5px;
    &.active {
      font-weight: bold;
    }
  }

  .right {
    padding-right: 60px;
    display: flex;
    .svgicon {
      fill: #808b91;
      &:not(:last-of-type) {
        margin-right: 20px;
      }
    }
  }

  .separator {
    width: 2px;
    height: 20px;
    background-color: #f2f3f4;
    margin: 0 20px;
  }
  
  .profile {
    height: 100%;
    padding-right: 15px;
    margin: 0 15px;
    border-right: 2px solid rgba(243, 244, 245, 0.20);
    &>a {
      
      display: flex;
      .user {
        white-space: nowrap;
      }
    }
  }

</style>